import { featureFlags } from "#/config/featureFlags";
import { ButtonFeatureFlag } from "#/types/featureFlags";

import { useFeatureFlags } from "./useFeatureFlags";

export const useEquityButtonFeatureFlag = () => {
  const featureFlag = useFeatureFlags<ButtonFeatureFlag>(
    featureFlags.equityButton,
  );
  const isEquityButtonEnabled = featureFlag?.isEnabled ?? true;
  const equityButtonTitle = featureFlag?.title ?? "Equity";
  const equityButtonTooltip = featureFlag?.tooltip;

  return { isEquityButtonEnabled, equityButtonTitle, equityButtonTooltip };
};
